<template>
    <div>
        <div class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-px-6 tw-pt-6 tw-pb-6 tw-border-0 md:tw-border-t md:tw-border-dark-grey">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/6 tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="h7 pb-2">GENERAL</div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-5/6 tw-border-b tw-border-dark-grey md:tw-border-0">

                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-4">
                    <div class="tw-text-4xl tw-uppercase tw-pt-4 md:tw-pt-0 tw-pb-1">CURRENT BALANCE <span>{{ $root.formatCurrency(user.dues_balance) }}</span></div>
                </div>

                <div class="tw-text-lg tw-mb-5">
                    When working under an IATSE Local 667 collective agreement, members will receive a variety of benefits dependent upon the individual production agreement with IATSE.
                    Based on the current collective agreement, the health and welfare benefits paid by producers could be a maxiumum of 4.5% and $12 per day plus Ontario PST.  The RRSP benefit could be a maxiumum of 6% and vacation pay could be a maxiumum of 8%.  The health and welfare and RRSP benefit percentage is calculated based upon the total of the gross wages plus vacation pay.
                </div>



                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-4">
                    <div class="tw-text-4xl tw-uppercase tw-pt-0 tw-pb-1">HOW TO PAY</div>
                </div>
                <div class="tw-text-lg tw-mb-5 tw-px-4">
                    <ol>
                        <li>Internet or Telephone banking through CIBC, TD Canada Trust, Scotia Bank, Bank of Montreal, ING or Royal Bank. You will be required to enter an account number. Our payee name is I.A.T.S.E. Local 667</li>
                        Your unique account number for internet banking is: {{ banking_account_id }}

                        <li>Credit Card - you can either complete the payment online by following the link below or pay in the Local 667 office in person</li>

                        <li>By cheque - please ensure your name is clearly indicated on your cheque</li>

                        <li>Direct Debit - you can pay by direct debit in the Local 667 office</li>
                    </ol>
                    <div class="tw-py-3">
                        <button type="button" class="main-btn" @click="goToBambora">Pay My Dues Now</button>
                    </div>
                    <div class="tw-pb-3">
                        If you have any issues or questions please reach out to the 667 office
                    </div>

                </div>


                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-4">
                    <div class="tw-text-4xl tw-uppercase tw-pt-0 tw-pb-1">DUES</div>
                </div>
                <div class="tw-text-lg tw-mb-5">
                    Any dues renewal will take effect the next business day after receiving payment


                    <smart-table
                        endpoint="membersdues.list"
                        :headers="headers"
                        @fetch-complete="summarizeData"
                        flat
                    >
                        <template v-slot:item.date_due="{ isMobile, item, header, value, index}">
                            {{ getDisplayDate(item) }}
                        </template>
                    </smart-table>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";
    import SmartTable from "@/Generic/SmartTable.vue";

    export default {
        name: "MemberDuesIndex",
        components: {SmartTable},
        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        props: {
            'user': {
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                bambora_link: null,
            }
        },
        computed: {
            headers() {
                return [
                    { text: "Date",             value: "date_due" ,         align: `start`,     sortable: false,    filterable: false},
                    { text: "Item",             value: "paid_item" ,        align: `start`,     sortable: false,    filterable: false},
                    { text: "Amount",           value: "amount_due" ,       align: `end`,       sortable: false,    filterable: false},
                    { text: "Payment",          value: "amount_payment" ,   align: `end`,       sortable: false,    filterable: false},
                    { text: 'User',             value: 'user_id',           align: ` d-none`,   sortable: true,     filterable: true,           search: this.$root.$page?.user?.id },

                ];
            },
            banking_account_id() {
                let user_info = this.user?.internal_code
                return user_info || 'NOT AVAILABLE: Please advise IATSE667 staff about this'
            },

        },
        methods:{
            summarizeData() {
                return null
            },
            getDisplayDate(member_due) {
                return member_due.date_issued || member_due.date_payment || member_due.date_deposit
            },
            goToBambora() {
                try {
                    if (this.bambora_link) {
                        window.location.href = this.bambora_link
                    } else {
                        axios.get(route('bambora.link').url())
                            .then(response => {
                                this.bambora_link = response.data
                                this.$root.snackbar?.success("Redirecting to Bambora Checkout")
                                setTimeout(() => {
                                    window.location.href = this.bambora_link
                                }, 1000)
                            })
                            .catch(error => {
                                console.log("Error retrieving link to Bambora Checkout")
                                this.$root.snackbar?.error("Error retrieving link to Bambora Checkout")
                            })
                    }
                } catch ($ex) {
                    console.log($ex)
                }
            },
            showFlashedMessages() {
                let should_display = !!this.$page?.flash?.success && !!this.$page?.flash?.message
                let success = this.$page?.flash?.success
                let message = this.$page?.flash?.message

                if (!should_display) {
                    return
                }

                setTimeout(() => {
                    if (success) {
                        this.$root.snackbar.success(message)
                    } else {
                        this.$root.snackbar.error(message)
                    }
                }, 1000)
            },
        },
        mounted () {
            // this.showFlashedMessages()
        },
    }
</script>
